import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AdminJobApply = () => {
  const [applications, setApplications] = useState([]);

  const fetchApplications = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/application/applications`);
      setApplications(res.data);
    } catch (err) {
      console.error('Failed to load applications:', err);
    }
  };

  useEffect(() => {
    fetchApplications();
  }, []);

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this application?');
    if (!confirmDelete) return;

    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/application/applications/${id}`);

      alert('Application deleted successfully.');
      fetchApplications(); // Refresh the list
    } catch (error) {
      console.error('Delete failed:', error);
      alert('Failed to delete application.');
    }
  };

  return (
    <div className="max-w-7xl mx-auto font-[Poppins] p-6">
      <h1 className="text-3xl font-bold mb-4">Job Applications</h1>
      <h2 className="text-xl text-gray-600 mb-6">Submitted Applications</h2>

      {applications.length === 0 ? (
        <p className="text-gray-500">No applications found.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-300 shadow-sm rounded-md overflow-hidden">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-2 text-left">Full Name</th>
                <th className="px-4 py-2 text-left">Email</th>
                <th className="px-4 py-2 text-left">Phone</th>
                <th className="px-4 py-2 text-left">Cover Letter</th>
                <th className="px-4 py-2 text-left">Resume</th>
                <th className="px-4 py-2 text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              {applications.map((app) => (
                <tr key={app.id} className="border-t">
                  <td className="px-4 py-2">{app.firstName} {app.lastName}</td>
                  <td className="px-4 py-2">{app.email}</td>
                  <td className="px-4 py-2">{app.phone}</td>
                  <td className="px-4 py-2 max-w-xs truncate">{app.coverLetter}</td>
                  <td className="px-4 py-2">
                    {app.resumePath ? (
                      <a
                        href={`${process.env.REACT_APP_API_URL}/${app.resumePath}`}
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue-600 hover:underline"
                      >
                        ⬇️ Download
                      </a>
                    ) : (
                      <span className="text-gray-500">No Resume</span>
                    )}
                  </td>
                  <td className="px-4 py-2">
                    <button
                      onClick={() => handleDelete(app.id)}
                      className="bg-red-500 hover:bg-red-600 text-white px-4 py-1 rounded-full text-sm"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminJobApply;
